interface Props {
  platform: string;
}

const platformConfig: Record<string, { label: string; color: string; icon: string }> = {
  meta: { label: 'Meta', color: 'blue', icon: 'M' },
  google: { label: 'Google', color: 'red', icon: 'G' },
  tiktok: { label: 'TikTok', color: 'black', icon: 'T' },
};

const colorClasses: Record<string, string> = {
  blue: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
  red: 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400',
  black: 'bg-gray-100 text-gray-900 dark:bg-gray-900/30 dark:text-gray-300',
};

export function PlatformIcon({ platform }: Props) {
  const config = platformConfig[platform.toLowerCase()] || platformConfig.meta;
  const classes = colorClasses[config.color];

  return (
    <div className={`inline-flex items-center justify-center w-8 h-8 rounded-full font-bold text-sm ${classes}`}>
      {config.icon}
    </div>
  );
}
